import isSubUrlOf from './isSubUrlOf';

// Expects an array of paths that are blacklisted. Example:
// isUrlBlacklisted(url, ['/developer/']);
const isUrlBlacklisted = (url, blacklistedRoutePrefixes) => {
  return blacklistedRoutePrefixes.some(path => isSubUrlOf(url, path));
};

export default isUrlBlacklisted;
